<template src="./closeOutsSummaryPanel.template.html"></template>
<script>
import moment from "moment-timezone";

export default {
  name: "closeOutsSummaryPanel",
  props: ["closeOutsSummaryPanel", "parentCallback", "hideSummaryPanel", "updateSchedulerConfig"],
  data() {
    return {
      headerColumnList: {
        PropertyName: {
          Label: "Property Name",
          IsChecked: true,
          ColumnName: "PropertyName"
        },
        UnitName: {
          Label: "Unit Name",
          IsChecked: true,
          ColumnName: "UnitName"
        },
        startDate: {
          Label: "startDate",
          IsChecked: true,
          ColumnName: "startDate"
        },
        endDate: {
          Label: "endDate",
          IsChecked: true,
          ColumnName: "endDate"
        },
        Avalibility: {
          Label: "Avalibility",
          IsChecked: true,
          ColumnName: "Avalibility"
        }
      },
      closeOutsList: [],
      loading: true,
      isSummaryLoading: false,
      closeOutDetailId: {
        closeOutId: -1
      },
      closeOutDetail: true,
      // closeOutList: true
    };
  },
  methods: {
    showCloseOutsSummaryPanel() {
      let vm = this;
      // console.log("inst", inst);
      vm.closeOutDetail = false;
      // vm.closeOutList = true;
      $("#roomInventorySummary").removeClass("animated fadeOutRight");
      $("#roomInventorySummary").addClass("expand animated fadeInRight");
      $(".clientList").removeClass("expand");
      $("#notification").removeClass("expand");
      $(".reservationSummary").removeClass("expand");
      $("#restrictionsSummary").removeClass("expand");
      $("#ratesSummary").removeClass("expand");
      $(".menuMaskRoomInventorySum").toggle();
      $("#roomInventorySummary").removeClass("menuMaskRoomInventorySum");
      // vm.isSummaryLoading = true;
      // vm.GetCloseOuts();
      vm.$store.state.bus.$emit('reset');
      $(this.$el)
        .find("ul.dropdown-menu")
        .click(function(e) {
          e.stopPropagation();
        });
    },
    closeSummaryPannel() {
      $(".menuMaskRoomInventorySum").hide();
      $("#roomInventorySummary").removeClass("expand fadeInRight");
      $("#roomInventorySummary").addClass("animated fadeOutRight");
      if (this.hideSummaryPanel) {
        this.hideSummaryPanel();
      }
      this.parentCallback({closeoutpanel: true})
    },
    // createNewRateOverRide() {
    //   let vm = this;
    //   vm.ratesDetail = true;
    //   vm.closeOutDetailId = {
    //     rateOverRideId: -1
    //   };
    //   vm.$router.push("/rateOverride/" + "-1");
    // },
    GetCloseOuts() {
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "GetCloseOuts",
        params: {
          // ClientId,
          PropertyId: null,
          UnitId: null
        },
        callback: function(err, response) {
          if (err) {
            return;
          }
          if (response) {
            vm.closeOutsList = response.recordsets[0];
            console.log("response in GetCloseOuts", response);
          }
          vm.isSummaryLoading = false;
        }
      });
    },
    formatDate(date){
      return moment(date).format("MMM DD YYYY");
    },
    // viewCloseOutsDetailById(inst) {
    //   let vm = this;
    //   console.log("inst", inst);
    //   vm.closeOutDetail = true;
    //   vm.closeOutDetailId = {
    //     closeOutId: inst.CloseOutId
    //   };
    // },
    hideDetailsSummary() {
      let vm = this;
      vm.closeOutDetail = false;
      // vm.GetCloseOuts();
      console.log("here in");
      vm.closeSummaryPannel();
    }
  },
  computed: {},
  mounted() {
  },
  watch: {
    closeOutsSummaryPanel: {
      handler: function(resObj, oldVal) {
        if (resObj == true) {
          this.showCloseOutsSummaryPanel();
        }
      },
      deep: true
    }
  },
  destroyed() {}
};
</script>